<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-08-02"></menubar>
    </div>
    <!--  左メニュー 終了 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t("label.point.common.IssuancePoints")}}</label>
        <narrow-down @click="pointDistribution" slot="cancel">{{$t("label.point.common.IssuancePointsCreate")}}</narrow-down>
      </head-title>
    </el-row>
    <!--  メインページ 開始  -->
    <div slot="body">

      <el-row class="m-top-5">
        <el-col class="title-box">
          <label>
            {{$t("label.point.common.PointBalance")}}
          </label>
        </el-col>
        <el-col class="point-title">
          <label class="point-font-style">
            {{ totailPont | format_number }}
          </label>
          <label class="input-font-size">
            {{$t("label.point.common.point")}}
          </label>
        </el-col>
      </el-row>

      <el-form
        class="margin-top-40"
        :model="query"
        :rules="rules"
        ref="rulesForm"
        label-position="left"
      >
        <el-form-item
          class="master-start"
          :label="$t('label.system.companyWalletPointDist.pointIssue')"
          prop="pointIssue"
          :rules="pointIssue">
          <el-input
            style="margin-left: 30px !important;"
            maxlength="10"
            v-model="query.pointIssue"
            :placeholder="$t('label.point.common.issuePointNumber')"
          >
          </el-input>
          <!-- <span>PT</span> -->
        </el-form-item>

        <el-row class="button-box">
          <sp-smart-button
            @click="companyWalletPointIssue">
            {{ $t("button.system.companyWalletPoint.issue") }}
          </sp-smart-button>
        </el-row>
      </el-form>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

      <loading-dialog :dialogVisible="showLoading" />

      <navigation-point-manage-popup
        :visible="navvisible">
      </navigation-point-manage-popup>
    </div>
    <!--  メインページ 終了  -->
  </main-layout>
</template>


<script>
import MainLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi"
import pointIssueFactory from "@/rules/rule-company-wallet-point-issue"
import SpSmartButton from "@/components/common/sp-smart-button"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/Home"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import NavigationPointManagePopup from "@/views/navigation/NavigationPointManagePopup"
import { commonCheckCustomerData } from "@/utils/commonUtils"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import NarrowDown from "@/components/common/generalButton/NarrowDown"
const STATUS_CODE = "Success";

export default {
  name: "companyWalletPointIssue",
  components: {
    LoadingDialog: LoadingDialog,
    MainLayout: MainLayout,
    Menubar: Menubar,
    headTitle: headTitle,
    SpSmartButton: SpSmartButton,
    elDialogPrompt,
    NarrowDown,
    NavigationPointManagePopup: NavigationPointManagePopup
  },
  data() {
    var validatePoint = (rule,value,callback) => {
      if(value == 0 ) {
        callback(new Error(this.$t('message.common.validation.pointIsson')))
      }else {
        callback()
      }
    }
    return {
      showLoading: false,
      navvisible: false,
      msgParam: this.$t("label.point.common.pointIssue"),
      centerDialogVisibleIsShow: false,
      buildingName: null,
      totailPont: 0,
      pointBalance: null,
      query: {
        pointIssue: "",
      },
      pointIssue: [
        {
        required: true,
        trigger: 'change',
        message: this.$t('message.common.validation.required', {
          field: this.$t('label.system.companyWalletPointDist.pointIssue')
        })
      },
      {
        max: 10,
        trigger: 'change',
        message: this.$t('message.common.validation.max', {
          field: this.$t('label.system.companyWalletPointDist.pointIssue'),
          length: 10
        })
      },
      {
        // pattern: /^[0-9]*[1-9][0-9]*$/,
        pattern: /^[0-9]*$/,
        trigger: 'change',
        message: this.$t('message.common.validation.type', {
          field: this.$t('label.system.companyWalletPointDist.pointIssue'),
          type: '半角数字'
        })
      },
      {
        pattern: /^[0-9]{1}[0-9]*$/,
        trigger: 'blur',
        message: this.$t('message.common.validation.pointIsson')
      },
      { validator: validatePoint, trigger: 'blur' }
      ],
      rules: pointIssueFactory.pointIssueRules(this),
    };
  },

  methods: {
    commonCheckCustomerData,
    getPointBalance() {
      SystemManageApi.companyWalletPointSearch({})
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if(!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.pointBalance = data.body.balance;
        this.totailPont = data.body.balance;
      });
    },

    isPassParam(param){
      if(param){
        this.centerDialogVisibleIsShow = false;
        this.showLoading = true;
        SystemManageApi.companyWalletPointIssue({
              amount: Number(this.query.pointIssue),
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          let statusCode = data.statusCode;
          if (STATUS_CODE == statusCode) {
            // 执行point追加
            this.totailPont = parseInt(this.totailPont) + parseInt(this.query.pointIssue);
            this.query.pointIssue = "0";
            this.submitSuccess();
          } else {
            this.$messageIotSuccess(this.$t("message.common.overMaxValueMessage", {
              field: this.$t("label.system.companyWalletPointDist.pointIssue"),
            }));
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
      }
    },

    companyWalletPointIssue() {
      this.$refs["rulesForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      });
    },
    /**
     * 页面回退
     */
    pageBack() {
      this.$router.push({
        name: "point-owner-management-top",
      });
    },
    pointDistribution() {
      this.$router.push({
        name: "system-company-wallet-point-dist-detail-add",
      });
    },
    /**
     * 发行成功
     */
    submitSuccess() {
      this.$messageIotSuccess(this.$t("label.point.common.issueSusess"));
    },
    checkCustomerData(){
      this.navvisible = commonCheckCustomerData("AD_GUIDE_POINT_FLAG", this)
    }
  },
  filters: {
    format_number: function (nStr) {
      nStr += "";
      let x = nStr.split(".");
      let x1 = x[0];
      let x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {

        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
  },
  mounted() {
    this.checkCustomerData()
    this.getPointBalance();
  },
  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "",
        title: "label.router.pointManagement",
      },
      {
        path: "",
        title: "label.router.Creditsissue",
      },
      {
        path: "",
        title: "label.router.managemenIssue",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
};
</script>

<style scoped lang="scss">

::v-deep .cancel-width {
  .my-button {
    width: 188px;
    height: 32px;
    padding: 0;
  }
}
.button-box {
  margin-top: 60px;
}
.el-input {
  width: 146px;
  height: 26px;
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  display: none;
}
.title-box {
  text-align: left;
  width: 97px;
  font-size: 16px;
  margin-right: 55px;
}
.point-title {
  width: 400px;
  text-align: left;
}

/* 修改placeholder提示字体颜色 */
::v-deep input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #B8B8B4;
  font-size: 14px;
}
.point-font-style {
  font-size: 20px;
  margin-right: 20px;
}
.input-font-size {
  font-size: 14px;
}
.margin-top-40 {
  margin-top: 40px;
}
::v-deep .el-form-item__content {
  font-size: 16px;
}
.el-form-item-input{
  font-size: 16px;
}
::v-deep .el-form-item__error {
  padding-left: 160px;
}
::v-deep .el-form-item__label {
  font-size: 16px;
}

::v-deep .cancel{
  margin-right: 24px !important;
}

::v-deep .create {
  display: none;
}

.master-start {
  width: 1000px;
}

::v-deep .master-start > .el-form-item__label::after {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
